export const filterInitialValues = {
  sortBy: false,
  ratings: false,
  categories: [],
  priceRange: 0,
};
